import styled from "styled-components";
import List from "@material-ui/core/List";

export const StatementActionButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

export const ScrollableList = styled(List)`
  width: 100%;
  flex-grow: 1;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const StatementFormDiv = styled.div`
  width: 75%;
  min-width: 400px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
`;

export const StatementSelectedListDiv = styled.div`
  width: 25%;
  min-width: 250px;
  height: 80%;
  max-height: 900px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const StatementSelectedListHeaderDiv = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
`;

export const StatementSelectedListBodyDiv = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`;

export const StatementActionsDiv = styled.div`
  border-bottom-style: solid;
  border-width: 1px;
  border-color: var(--menu-text);
  display: flex;
  flex-direction:row;
  align-items: center;
    
`;